// extracted by mini-css-extract-plugin
export default {"fieldTitle":"fieldTitle-Yr4ub","list":"list-zwO6g","requiredFields":"requiredFields-uk4fC","leftList":"leftList-QTQ8K","rightList":"rightList-pvEC2","fieldsList":"fieldsList-hm4Gj"};